import type React from 'react';
import { DraggableItemTypes } from 'owa-dnd';
import { getDragItemType } from 'owa-dnd/lib/utils/dragDataUtil';

export default function onMailListDragOver(evt: React.DragEvent<EventTarget>): void {
    evt.preventDefault();

    const dragTypes = [getDragItemType(), ...evt.dataTransfer.types];
    const isEventOrTask = dragTypes.some(
        itemType =>
            itemType === DraggableItemTypes.Todo ||
            itemType === DraggableItemTypes.CalendarItem ||
            itemType?.startsWith(`${DraggableItemTypes.CalendarItem}_`)
    );

    if (isEventOrTask) {
        evt.dataTransfer.dropEffect = 'none';
    } else if (evt.ctrlKey) {
        evt.dataTransfer.dropEffect = 'copy';
    }
}
